<template>
  <v-container
    ref="container"
    class="fill-height page"
    fluid
  >
    <div class="overlay" />

    <v-row
      class="f-flex"
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card class="elevation-12">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>Mon nouveau mot de passe</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <p class="black--text">
              Veuillez saisir votre nouveau mot de passe pour le réinitialiser.
            </p>
            <v-form @submit.prevent="send">
              <v-text-field
                v-model="password"
                label="Mot de passe"
                name="email"
                prepend-icon="mdi-key"
                type="password"
                :error-messages="passwordErrors"
                @blur="$v.password.$touch()"
              />

              <br>
              <v-text-field
                v-model="passwordConf"
                label="Confirmer votre mot de passe"
                name="passwordConf"
                prepend-icon="mdi-key"
                type="password"
                :error-messages="passwordConfErrors"
                @blur="$v.passwordConf.$touch()"
              />
              <br>

              <div>
                <v-checkbox
                  v-model="prMinLength"
                  disabled
                  hide-details
                  style="margin:0"
                >
                  <template v-slot:label>
                    Minimum 8 caractères
                  </template>
                </v-checkbox>

                <v-checkbox
                  v-model="prHasUpper"
                  disabled
                  hide-details
                  style="margin:0"
                >
                  <template v-slot:label>
                    Au moins une lettre majuscule
                  </template>
                </v-checkbox>

                <v-checkbox
                  v-model="prHasLower"
                  disabled
                  hide-details
                  style="margin:0"
                >
                  <template v-slot:label>
                    Au moins une lettre minuscule
                  </template>
                </v-checkbox>

                <v-checkbox
                  v-model="prHasDigit"
                  disabled
                  hide-details
                  style="margin:0"
                >
                  <template v-slot:label>
                    Au moins un chiffre
                  </template>
                </v-checkbox>

                <v-checkbox
                  v-model="prHasSpecial"
                  disabled
                  hide-details
                  style="margin:0"
                >
                  <template v-slot:label>
                    Au moins un caractère spécial
                  </template>
                </v-checkbox>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="$router.push('/account/login')"
            >
              Retour à la connexion
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              dark
              :loading="inProgress"
              @click="send()"
            >
              Envoyer
            </v-btn>
          </v-card-actions>

          <v-alert
            v-if="hasError"
            dense
            outlined
            type="error"
            class="ma-3"
          >
            {{ hasError }}
          </v-alert>
          <br>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, sameAs, helpers } from 'vuelidate/lib/validators'

  const pass = helpers.regex('pass', /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/)

  export default {
    mixins: [validationMixin],
    validations: {
      password: { required, pass },
      passwordConf: {
        required,
        sameAsPassword: sameAs('password'),
      },
    },
    auth: false,
    layout: 'empty',
    data: () => ({
      inProgress: false,
      hasError: '',
      password: '',
      passwordConf: '',
    }),
    computed: {
      passwordErrors () {
        const errors = []
        if (!this.$v.password.$dirty) return errors
        !this.$v.password.required && errors.push('Ce champ est manquant.')
        !this.$v.password.pass && errors.push('Minimum 8 caractères, au moins une lettre majuscule, au moins une lettre minuscule, au moins un caractère spécial et un chiffre')
        return errors
      },
      passwordConfErrors () {
        const errors = []
        if (!this.$v.passwordConf.$dirty) return errors
        !this.$v.passwordConf.required && errors.push('Ce champ est manquant.')
        !this.$v.passwordConf.sameAsPassword && errors.push('Les mots de passe sont différents.')
        return errors
      },
      prMinLength () {
        return this.password && this.password.length >= 8
      },
      prHasUpper () {
        return /(?=.*?[A-Z])/.test(this.password)
      },
      prHasLower () {
        return /(?=.*?[a-z])/.test(this.password)
      },
      prHasDigit () {
        return /(?=.*?[0-9])/.test(this.password)
      },
      prHasSpecial () {
        return /(?=.*?[#?!@$%^&*-])/.test(this.password)
      },
    },
    mounted () {
    },
    methods: {
      send () {
        this.hasError = ''
        const params = new URLSearchParams(window.location.search)
        const token = params.get('token')
        if (!token) {
          this.hasError = 'Token non disponible'
          return
        }

        this.$v.$touch()
        if (this.$v.$invalid) {
          this.hasError = 'Un ou plusieurs champs du formulaire semblent manquants ou incorrects.'
          return
        }

        this.inProgress = true
        this.$auth.resetPassword({
          token: token,
          password: this.password,
        })
          .then(() => {
            this.inProgress = false
            this.$router.push('/account/login')
          })
          .catch((err) => {
            console.log(err.response)
            this.inProgress = false
            this.hasError = err.response.data.error || err
          })
      },
    },
  }
</script>

<style scoped>
.page {
  padding: 0!important;
  position: relative;
  background-position: center;
  background-size: cover;
  background-image: url('https://imaginary.service.codeisalie.fr/resize?height=80&url=https://storage.service.lecalamedor.fr/strapi/DSC_0173_5f06dace78.JPG');
}
.overlay {
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  height:100%;
  width:100%
}
</style>
